exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empresas-column {\n  overflow-y: scroll;\n  height: calc(100% - 73px); }\n\nmd-tab-group {\n  height: calc(95vh - 120px); }\n\n/deep/ .mat-tab-body-wrapper {\n  height: 100%; }\n\nmd-tab-body {\n  height: 100%; }\n\n.empresas-row {\n  height: 80%;\n  display: -ms-flexbox;\n  display: flex; }\n\n.height-100 {\n  height: 100%; }\n\n.centered-column {\n  margin-left: auto;\n  margin-right: auto; }\n\n.spinner {\n  float: right;\n  height: 35px;\n  width: 35px; }\n\n.save-buttons {\n  padding-top: 15px;\n  text-align: center; }\n\n.productos {\n  margin-left: 10px;\n  margin-top: 25px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 50%; }\n\n.productoItem {\n  margin-bottom: 5px; }\n\n.checkbox-cont {\n  height: 78px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .checkbox-cont md-checkbox {\n    margin-top: .5rem;\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/rol-detail/rol-detail.component.scss
// module id = ../../../../../src/app/components/abm/rol-detail/rol-detail.component.scss
// module chunks = 0